export default {
  reset: 'RESET PASSWORD',
  invalidError: 'Email or password are incorrect.',
  or: 'or',
  register: 'Create an account',
  forgot: 'Forgot password?',
  backToLogin: 'Back to login'
};



// WEBPACK FOOTER //
// ./src/views/guest/reset-password/ResetPassword.messages.js